import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';

const formScheme: ItemScheme[] = [
	{
		type: MagicField.RADIOLIST,
		key: 'fast',
		title: 'Ayuno',
		settings: {
			required: true,
		},
		inLine: true,
		children: [
			{
				value: '1',
				title: 'base.yes',
			},
			{
				value: '0',
				title: 'base.no',
			},
		],
	},
	// RADEK 1
	{
		type: MagicField.HSTACK,
		children: [
			// SLOUPEC 1
			{
				type: MagicField.CONTAINER,
				children: [
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Hematología',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hematologiaHemograma',
								title: 'Hemograma',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hematologiaMicrohematocrito',
								title: 'Microhematocrito',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hematologiaVsg',
								title: 'VSG',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hematologiaReticulocitos',
								title: 'Reticulocitos',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hematologiaMorfologiaCelular',
								title: 'Morfología celular',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hematologiaCelulasLe',
								title: 'Células LE',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hematologiaHematozoario',
								title: 'Hematozoario',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hematologiaVitaminaB12',
								title: 'Vitamina B12',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hematologiaAcidoFolico',
								title: 'Ácido Fólico',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hematologiaHierroSerico',
								title: 'Hierro sérico',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hematologiaTransferrina',
								title: 'Transferrina',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hematologiaSaturacionDeTransferrina',
								title: 'Saturación de Transferrina',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hematologiaFerritina',
								title: 'Ferritina',
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Hemostasia',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hemostasiaPlaquetas',
								title: 'Plaquetas',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hemostasiaTiempoDeSangria',
								title: 'Tiempo de Sangría',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hemostasiaTiempoDeCoagulacion',
								title: 'Tiempo de Coagulación',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hemostasiaTiempoDeProtrombina',
								title: 'Tiempo de Protrombina',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hemostasiaInr',
								title: 'INR',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hemostasiaTiempoParcialDeTromboplastina',
								title: 'Tiempo parcial de Tromboplastina',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hemostasiaRetraccionDeCoagulo',
								title: 'Retracción de Coágulo',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hemostasiaProteinaS',
								title: 'Proteína S',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hemostasiaProteinaC',
								title: 'Proteína C',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hemostasiaFibrinogeno',
								title: 'Fibrinógeno',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hemostasiaAnticoagulanteLupico',
								title: 'Anticoagulante lúpico',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hemostasiaSaturaionDeTransferrina',
								title: 'Saturación de Transferrina',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hemostasiaDimeroD',
								title: 'Dímero D',
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Tipificación',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'tipificacionGrupo',
								title: 'Grupo',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'tipificacionFactorRh',
								title: 'Factor Rh',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'tipificacionCoombsDirecto',
								title: 'Coombs Directo',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'tipificacionCoombsIndirecto',
								title: 'Coombs Indirecto',
							},
						],
					},
				],
			},
			// SLOUPEC 2
			{
				type: MagicField.CONTAINER,
				children: [
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Químicos',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosGlucosaEnAyunas',
								title: 'Glucosa en ayunas',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosGlucosaPostPrandial',
								title: 'Glucosa post-prandial',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosGlucosaTestToleranciaOral',
								title: 'Glucosa: Test tolerancia oral',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'quimicosGlucosaTestToleranciaOral',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'quimicosGlucosaTestToleranciaOralWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'quimicosGlucosaTestToleranciaOralRadio',
												title:
													'NOTA: Asegúrese que el paciente NO TIENE DIAGNÓSTICO DE DIABETES PREVIA antes de solicitar esa prueba',
												settings: {
													// required: true,
												},
												inLine: true,
												children: [
													{
														value: 'quimicosGlucosaTestToleranciaOral50g',
														title: 'Carga 50 gramos',
													},
													{
														value: 'quimicosGlucosaTestToleranciaOral75g',
														title: 'Carga 75 gramos',
													},
												],
											},
											{
												type: MagicField.TEXT_FIELD,
												key: 'quimicosGlucosaTestToleranciaOtraCarga',
												title: 'Otra carga',
											},
											{
												type: MagicField.TEXT_FIELD,
												key: 'quimicosGlucosaTestToleranciaTiemposDeTomaDeMuestra',
												title: 'Tiempos de toma de muestra',
											},
											{
												type: MagicField.TEXT_FIELD,
												key: 'quimicosGlucosaTestToleranciaNotaAdicional',
												title: 'Nota adicional',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosHemoglobinaA1c',
								title: 'Hemoglobina A1C',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosUrea',
								title: 'Úrea',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosCreatinina',
								title: 'Creatinina',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosAcidoUrico',
								title: 'Ácido Úrico',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosColesterol',
								title: 'Colesterol',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosTrigliceridos',
								title: 'Triglicéridos',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosHDLColesterol',
								title: 'H.D.L. Colesterol',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosLDLColesterol',
								title: 'L.D.L. Colesterol',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosVLDLColesterol',
								title: 'V.L.D.L. Colesterol',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosApolipoproteinaA1',
								title: 'Apolipoproteína A1',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosApolipoproteinaB',
								title: 'Apolipoproteína B',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosBilirrubinaTotal',
								title: 'Bilirrubina Total',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosBilirrubinaDirecta',
								title: 'Bilirrubina Directa',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosBilirrubinaIndirecta',
								title: 'Bilirrubina Indirecta',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosProteinasTotales',
								title: 'Proteínas totales',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosAlbUmina',
								title: 'Albúmina',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosGlobulinas',
								title: 'Globulinas',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'quimicosIndiceAG',
								title: 'Índice A/G',
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Enzimas',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'enzimasGgt',
								title: 'G.G.T',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'enzimasTgo',
								title: 'T.G.O.',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'enzimasTgp',
								title: 'T.G.P.',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'enzimasFosfatasaAlcalina',
								title: 'Fosfatasa Alcalina',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'enzimasFosfatasaAcidaTotal',
								title: 'Fosfatasa Ácida Total',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'enzimasFosfatasaAcProstatica',
								title: 'Fosfatasa Ac. Prostática',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'enzimasAmilasa',
								title: 'Amilasa',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'enzimasLipasa',
								title: 'Lipasa',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'enzimasDeshidrogenasaLactica',
								title: 'Deshidrogenasa Láctica',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'enzimasCpk',
								title: 'C.P.K.',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'enzimasCpmb',
								title: 'C.K.-MB',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'enzimasTroponinaI',
								title: 'Troponina I',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'enzimasMioglobina',
								title: 'Mioglobina',
							},
						],
					},
				],
			},
			// SLOUPEC 3
			{
				type: MagicField.CONTAINER,
				children: [
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Electrolitos',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'electrolitosSodio',
								title: 'Sodio',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'electrolitosPotasio',
								title: 'Potasio',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'electrolitosCloro',
								title: 'Cloro',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'electrolitosCalcio',
								title: 'Calcio',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'electrolitosFosforo',
								title: 'Fósforo',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'electrolitosMagnesio',
								title: 'Magnesio',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'electrolitosLitio',
								title: 'Litio',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'electrolitosSodioUrinario',
								title: 'Sodio Urinario',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'electrolitosPotasioUrinario',
								title: 'Potasio Urinario',
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Inmunologia',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaAsto',
								title: 'ASTO',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaPcrCuantitativa',
								title: 'P.C.R. Cuantitativa',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaFrCuantitativo',
								title: 'F.R. Cuantitativo',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaVdrl',
								title: 'V.D.R.L',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaIgA',
								title: 'IgA',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaIgE',
								title: 'IgE',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaIgG',
								title: 'IgG',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaIgM',
								title: 'IgM',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaAglutinacionesFebriles',
								title: 'Aglutinaciones Febriles',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaC3',
								title: 'C3',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaC4',
								title: 'C4',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaAna',
								title: 'ANA',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaAntiDna',
								title: 'Anti DNA',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaAnticardiolipinaIgA',
								title: 'Anticardiolipina IgA',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaAnticardiolipinaIgG',
								title: 'Anticardiolipina IgG',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaAnticardiolipinaIgM',
								title: 'Anticardiolipina IgM',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaAntiCcp',
								title: 'Anti CCP',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaAntiRo',
								title: 'Anti RO (Anti SSA)',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaAntiLa',
								title: 'Anti LA (Anti SSB)',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaFrIgA',
								title: 'FR IgA',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaAlergenosRespiratorios',
								title: 'Alergenos Respiratorios',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaAlergenosAlimenticios',
								title: 'Alergenos Alimenticios',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'inmunologiaAlergenosRespiratoriosDigestivos',
								title: 'Alergenos Respiratorios + Digestivos',
							},
						],
					},
				],
			},
		],
	},
	// RADEK 2
	{
		type: MagicField.HSTACK,
		children: [
			// SLOUPEC 1
			{
				type: MagicField.CONTAINER,
				children: [
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Immuno infecciosas',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'immunoInfecciosasTpha',
								title: 'TPHA',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'immunoInfecciosasHelicobacterPyloriIgG',
								title: 'Helicobacter Pylori IgG',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'immunoInfecciosasToxoplasma',
								title: 'Toxoplasma',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'immunoInfecciosasToxoplasma',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'immunoInfecciosasToxoplasmaWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasToxoplasmaIgG',
												title: 'IgG',
											},
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasToxoplasmaIgM',
												title: 'IgM',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'immunoInfecciosasCMV',
								title: 'CMV',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'immunoInfecciosasCMV',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'immunoInfecciosasCMVWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasCMVIgG',
												title: 'IgG',
											},
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasCMVIgM',
												title: 'IgM',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'immunoInfecciosasRubeola',
								title: 'Rubeola',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'immunoInfecciosasRubeola',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'immunoInfecciosasRubeolaWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasRubeolaIgG',
												title: 'IgG',
											},
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasRubeolaIgM',
												title: 'IgM',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'immunoInfecciosasHerpesI',
								title: 'Herpes I',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'immunoInfecciosasHerpesI',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'immunoInfecciosasHerpesIWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasHerpesIIgG',
												title: 'IgG',
											},
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasHerpesIIgM',
												title: 'IgM',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'immunoInfecciosasHerpesII',
								title: 'Herpes II',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'immunoInfecciosasHerpesII',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'immunoInfecciosasHerpesIIWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasHerpesIIIgG',
												title: 'IgG',
											},
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasHerpesIIIgM',
												title: 'IgM',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'immunoInfecciosasMononucleosisInfecciosa',
								title: 'Mononucleosis infecciosa',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'immunoInfecciosasACHIV12',
								title: 'Ac. HIV 1-2',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'immunoInfecciosasWesternBlot',
								title: 'Western Blot',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'immunoInfecciosasHepatitisA',
								title: 'Hepatitis A',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'immunoInfecciosasHepatitisA',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'immunoInfecciosasHepatitisAWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasHepatitisAAntiIgG',
												title: 'Anti-IgG',
											},
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasHepatitisAAntiIgM',
												title: 'Anti-IgM',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'immunoInfecciosasHepatitisB',
								title: 'Hepatitis B',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'immunoInfecciosasHepatitisB',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'immunoInfecciosasHepatitisBWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasHepatitisBHBsAg',
												title: 'HBs Ag',
											},
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasHepatitisBAntiHBs',
												title: 'Anti-HBs',
											},
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasHepatitisBHbeAg',
												title: 'Hbe Ag',
											},
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasHepatitisBAntiHBe',
												title: 'Anti-HBe',
											},
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasHepatitisBAntiCoreIgG',
												title: 'Anti Core IgG',
											},
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasHepatitisBAntiCoreIgM',
												title: 'Anti Core IgM',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'immunoInfecciosasHepatitisChepatitisC',
								title: 'Hepatitis CHepatitis C',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'immunoInfecciosasHepatitisChepatitisC',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'immunoInfecciosasHepatitisChepatitisCWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.CHECKBOX,
												key: 'immunoInfecciosasHepatitisBAntiHCVIgG',
												title: 'Anti HCV - IgG',
											},
										],
									},
								],
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Drogas / Fármacos',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'drogasAcValproico',
								title: 'Ac. Valproico',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'drogasFenitoina',
								title: 'Fenitoína',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'drogasFenobarbital',
								title: 'Fenobarbital',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'drogasCarbamazepina',
								title: 'Carbamazepina',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'drogasCocaina',
								title: 'Cocaina',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'drogasMarihuana',
								title: 'Marihuana',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'drogasOpaceos',
								title: 'Opiáceos',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'drogasAnfetaminas',
								title: 'Anfetaminas',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'drogasBarbituricos',
								title: 'Barbitúricos',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'drogaCiclosporina',
								title: 'Ciclosporina',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'drogasPanelMultidrogas',
								title: 'Panel Multidrogas (orina)',
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Gasometría',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'gasomeriaGasometriaVenosa',
								title: 'Gasometría Venosa',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'gasomeriaGasometriaArterial',
								title: 'Gasometría Arterial',
							},
						],
					},
				],
			},
			// SLOUPEC 2
			{
				type: MagicField.CONTAINER,
				children: [
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Hormonas',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasTsh',
								title: 'TSH',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasT3Libre',
								title: 'T3 libre',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasT4Libre',
								title: 'T4 libre',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasLH',
								title: 'LH',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'hormonasLH',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'hormonasLHWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'hormonasLHRadio',
												title: 'Seleccionar una opción',
												settings: {
													required: true,
												},
												children: [
													{
														value: 'hormonasLHCasual',
														title: 'Casual',
													},
													{
														value: 'hormonasLHOtroDieDelCicloMenstrual',
														title: 'Otro día del ciclo menstrual',
													},
													{
														value: 'hormonasLHDia3a5DelCiclo',
														title: 'Día 3 a 5 del ciclo',
													},
												],
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasFSH',
								title: 'FSH',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'hormonasFSH',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'hormonasFSHWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'hormonasFSHRadio',
												title: 'Seleccionar una opción',
												settings: {
													required: true,
												},
												children: [
													{
														value: 'hormonasFSHCasual',
														title: 'Casual',
													},
													{
														value: 'hormonasFSHOtroDieDelCicloMenstrual',
														title: 'Otro día del ciclo menstrual',
													},
													{
														value: 'hormonasFSHDia3a5DelCiclo',
														title: 'Día 3 a 5 del ciclo',
													},
												],
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasProlactina',
								title: 'Prolactina',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'hormonasProlactina',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'hormonasProlactinaWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'hormonasProlactinaRadio',
												title: 'Seleccionar una opción',
												settings: {
													required: true,
												},
												inLine: true,
												children: [
													{
														value: 'hormonasProlactinaTotal',
														title: 'Total',
													},
													{
														value: 'hormonasProlactinaConDiluciones',
														title: 'Con diluciones',
													},
												],
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasEstradiol',
								title: 'Estradiol',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasProgesterona',
								title: 'Progesterona',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'hormonasProgesterona',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'hormonasProgesteronaWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'hormonasProgesteronaRadio',
												title: 'Seleccionar una opción',
												settings: {
													required: true,
												},
												children: [
													{
														value: 'hormonasProgesteronaDia2123DelCiclo',
														title: 'Día 21-23 del ciclo',
													},
													{
														value: 'hormonasProgesteronaConDiluciones',
														title: 'Con diluciones',
													},
													{
														value: 'hormonasProgesteronaCasual',
														title: 'Casual',
													},
												],
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasTestosteronaTotal',
								title: 'Testosterona Total',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasTestosteronaLibre',
								title: 'Testosterona Libre',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasSHBG',
								title: 'SHBG',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonas17Progesterona',
								title: '17 (OH) Progesterona',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasBetaHCGCuantitativa',
								title: 'Beta HCG Cuantitativa',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasBetaHCGCualitativa',
								title: 'Beta HCG Cualitativa',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasACTH',
								title: 'ACTH',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'hormonasACTH',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'hormonasACTHWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.TEXT_FIELD,
												key: 'hormonasACTHAm',
												title: 'a.m.',
											},
											{
												type: MagicField.TEXT_FIELD,
												key: 'hormonasACTHPm',
												title: 'p.m.',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasCortisol',
								title: 'Cortisol',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'hormonasCortisol',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'hormonasCortisolWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.TEXT_FIELD,
												key: 'hormonasCortisolAm',
												title: 'a.m.',
											},
											{
												type: MagicField.TEXT_FIELD,
												key: 'hormonasCortisolPm',
												title: 'p.m.',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasInsulinaBasal',
								title: 'Insulina Basal',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasInsulinaPostprandial',
								title: 'Insulina Postprandial',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasPeptidoC',
								title: 'Péptido C',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasParatohormona',
								title: 'Paratohormona',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasIGF1',
								title: 'IGF1',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasIGFBP3',
								title: 'IGFBP3',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasAldosterona',
								title: 'Aldosterona',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'hormonasAldosterona',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'hormonasAldosteronaWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'hormonasAldosteronaRadio',
												title: 'Seleccionar una opción',
												settings: {
													required: true,
												},
												inLine: true,
												children: [
													{
														value: 'hormonasAldosteronaAcostado',
														title: 'Acostado',
													},
													{
														value: 'hormonasAldosteronaDePie',
														title: 'De Pie',
													},
												],
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasAndrostenediona',
								title: 'Androstenediona',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hormonasDHEASS',
								title: 'DHEAS-S',
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Marcadores tumorales',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'marcadoresTumoralesCea',
								title: 'CEA (Ag. Carcinoembrionario)',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'marcadoresTumoralesaAfp',
								title: 'AFP (Alfa fetoproteína)',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'marcadoresTumoralesPsaTotal',
								title: 'PSA Total (Ag. Prostático específico)',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'marcadoresTumoralesPsaLibre',
								title: 'PSA Libre',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'marcadoresTumoralesCa15',
								title: 'CA 15-3 (Ca. Mamario)',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'marcadoresTumoralesCa19',
								title: 'CA 19-9 (Ca. Gástrico Pancreático)',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'marcadoresTumoralesCa125',
								title: 'CA 125 (Ca. Ovario)',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'marcadoresTumoralesCa75',
								title: 'CA 72-4 (Ca. Estómago)',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'marcadoresTumoralesTiroglobulina',
								title: 'Tiroglobulina',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'marcadoresTumoralesAntiTiroqlobulina',
								title: 'Anti-Tiroglobulina (Anti-Tg)',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'marcadoresTumoralesAntiTiroperoxidasa',
								title: 'Anti tiroperoxidasa (Anti TPO)',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'marcadoresTumoralesAntiReceptor',
								title: 'Anti receptor TSH (Anti RcTSH)',
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Líquidos',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'liquidosCitoquimicoYBacteriologico',
								title: 'Citoquímico y bacteriológico',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'liquidosOtros',
								title: 'Otros',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'liquidosOtros',
								children: [
									{
										type: MagicField.CONTAINER,
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.TEXT_FIELD,
												key: 'liquidosOtrosEspecifique',
												title: 'Especifique',
											},
										],
									},
								],
							},
						],
					},
				],
			},
			// SLOUPEC 3
			{
				type: MagicField.CONTAINER,
				children: [
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Orina',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'orinalementalMicroscopico',
								title: 'Orina elemental microscópico',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'orinaProteinuria',
								title: 'Proteinuria',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'orinaProteinuria',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'orinaProteinuriaWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.CHECKBOX,
												key: 'orinaProteinuriaOrinaParcial',
												title: 'Orina parcial',
											},
											{
												type: MagicField.CHECKBOX,
												key: 'orinaProteinuriaOrinasEn24Horas',
												title: 'Orina en 24 horas',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'orinaDepuracionDeCreatina',
								title: 'Depuración de creatina',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'orinaDepuracionDeCreatina',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'orinaDepuracionDeCreatinaWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.CHECKBOX,
												key: 'orinaDepuracionDeCreatinaOrinaParcial',
												title: 'Orina parcial',
											},
											{
												type: MagicField.CHECKBOX,
												key: 'orinaDepuracionDeCreatinaOrinasEn24Horas',
												title: 'Orina en 24 horas',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'orinaMicroalbuminuria',
								title: 'Microalbuminuria',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'orinaMicroalbuminuria',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'orinaMicroalbuminuriaWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.CHECKBOX,
												key: 'orinaMicroalbuminuriaOrinaParcial',
												title: 'Orina parcial',
											},
											{
												type: MagicField.CHECKBOX,
												key: 'orinaMicroalbuminuriaOrinasEn24Horas',
												title: 'Orina en 24 horas',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'orinaRelacionCalcio',
								title: 'Relación calcio/creatinia',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'orinaRelacionCalcio',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'orinaRelacionCalcioWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.CHECKBOX,
												key: 'orinaRelacionCalcioOrinaParcial',
												title: 'Orina parcial',
											},
											{
												type: MagicField.CHECKBOX,
												key: 'orinaRelacionCalcioOrinasEn24Horas',
												title: 'Orina en 24 horas',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'orinaUrocultivo',
								title: 'Urocultivo y prueba de sensibilidad antimicrobiana',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'orinaInvestigacionDeBar',
								title: 'Investigación de BAAR',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'orinaSeriado',
								title: 'Orina seriada',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'orinaSeriado',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'orinaSeriadoWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.TEXT_FIELD,
												key: 'orinaSeriadoNumeroDeMuestras',
												title: 'muestras',
											},
										],
									},
								],
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Heces',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hecesCoproparasitario',
								title: 'Coproparasitario',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hecesSeriado',
								title: 'Heces seriadas',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'hecesSeriado',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'hecesSeriadoWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.TEXT_FIELD,
												key: 'hecesSeriadoNumeroDeMuestras',
												title: 'muestras',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hecesCoprodigestivo',
								title: 'Coprodigestivo',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hecesSangreOculta',
								title: 'Sangre Oculta',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hecesPolimorfonucleares',
								title: 'Polimorfonucleares',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hecesCoprocultivo',
								title: 'Coprocultivo',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hecesRotavirus',
								title: 'Rotavirus',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hecesAdenovirus',
								title: 'Adenovirus',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hecesActividadTriptica',
								title: 'Actividad tríptica',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hecesAzucaresReductoresYNoReductores',
								title: 'Azúcares reductores y no reductores',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'hecesAntigeno',
								title: 'Antígeno fecal',
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Microbiología',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'microbiologiaMestraDe',
								title: 'Muestra de',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'microbiologiaMestraDe',
								children: [
									{
										type: MagicField.CONTAINER,
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.TEXT_FIELD,
												key: 'microbiologiaMestraDeEspecifique',
												title: 'Especifique',
												settings: {
													required: true,
												},
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'microbiologiaKOH',
								title: 'KOH',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'microbiologiaGram',
								title: 'Gram',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'microbiologiaZiehlNeelsen',
								title: 'Ziehl Neelsen',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'microbiologiaZiehlNeelsen',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'microbiologiaZiehlNeelsenWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.TEXT_FIELD,
												key: 'microbiologiaZiehlNeelsenNumeroDeMuestras',
												title: 'muestras',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'microbiologiaCultivoYPruebaDeSensibilidadAntimicrobiana',
								title: 'Cultivo y prueba de sensibilidad antimicrobiana',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value:
									'microbiologiaCultivoYPruebaDeSensibilidadAntimicrobiana',
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'microbiologiaCultivoYPruebaDeSensibilidadAntimicrobianaWrapper',
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.TEXT_FIELD,
												key: 'microbiologiaCultivoYPruebaDeSensibilidadAntimicrobianaEspecifique',
												title: 'en',
											},
										],
									},
								],
							},
							{
								type: MagicField.CHECKBOX,
								key: 'microbiologiaHemocultivo',
								title: 'Hemocultivo',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'microbiologiaCultivoParaMicrobacterias',
								title: 'Cultivo para microbacterias',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'microbiologiaCultivoParaHongos',
								title: 'Cultivo para hongos',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'microbiologiaOtros',
								title: 'Otros',
							},
							{
								settings: {
									equal: true,
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								value: 'microbiologiaOtros',
								children: [
									{
										type: MagicField.CONTAINER,
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.TEXT_FIELD,
												key: 'microbiologiaOtrosEspecifique',
												title: 'Especifique',
											},
										],
									},
								],
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						children: [
							{
								type: MagicField.TEXT,
								subType: 'category',
								title: 'Otros',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'otrosTamizajeMetabolico',
								title: 'Tamizaje Metabólico',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'otrosGrupoYFactorRhRecienNacido',
								title: 'Grupo y Factor Rh Recién Nacido',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'otrosTamizajeMetabolicoRecienNacido',
								title: 'Tamizaje Metabolico recién nacido',
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.TEXTAREA,
		key: 'otherTests',
		title: 'diabetes.laboratoryExam.otherTests',
	},
	{
		type: MagicField.TEXTAREA,
		key: 'interestOfLaboratoryData',
		title: 'diabetes.laboratoryExam.interestOfLaboratoryData',
	},
];

export default formScheme;
